/**
 * The duration a sign-up discount for a fd new retailer will be extended if it hasn't been used
 * PRD: https:www.notion.so/Auto-extend-FD-Credit-for-3-Days-XP-890e63dd95dc4db2a89d7cf7d9e3a931.
 */
export const FAIRE_DIRECT_AUTO_EXTEND_FIRST_ORDER_INCENTIVE_DURATION_IN_MILLISECONDS = 'FAIRE_DIRECT_AUTO_EXTEND_FIRST_ORDER_INCENTIVE_DURATION_IN_MILLISECONDS';
